import { call, select } from 'redux-saga/effects';

import { RT } from '../../../../shared/types';
import { actions } from '../reducer';
import { teamsModel } from '../../../teams';
import { collaborationApi } from '../../../../shared/api';
import { pagesModel } from '../../../pages';
import { createNotification, snackbarModel } from '../../../snackbar';

export function* deleteComment({
  payload: { threadId, commentId },
}: ReturnType<typeof actions.deleteComment>) {
  const currentTeam: RT<
    typeof teamsModel.selectors.selectCurrentTeamWithError
  > = yield select(teamsModel.selectors.selectCurrentTeamWithError);
  const currentPage: RT<
    typeof pagesModel.selectors.selectCurrentPageWithError
  > = yield select(pagesModel.selectors.selectCurrentPageWithError);

  try {
    yield call(collaborationApi.deleteComment, {
      pageId: currentPage.id,
      teamId: currentTeam.id,
      threadId,
      commentId,
    });
  } catch (err) {
    snackbarModel.actions.addNotificationAction(
      createNotification('error', 'Failed to delete a comment')
    );
  }
}
